<div class="main-tab-title-box">
    <mat-card-title class="main-title">Lexis: Academic Word List</mat-card-title>
    <div>
        <analysis-options></analysis-options>
    </div>
</div>
<mat-card-content>
      <div class="box-login">
        <span class="main-box-title-14">As this is a subscriber’s feature, you are seeing sample results. In order to  <br>see the real results of your text, <u class="main-box-value-14-bold"><a href="https://textinspector.com/subscription-details/" style="color: #2A3654;" target="_blank" rel="noopener noreferrer">SUBSCRIBE NOW.</a></u></span>
    </div>


    <div id="button-switch-box">
        <div class="button-container left" [ngClass]="{'selected': isSelected('summary')}" (click)="selectMenuItem('summary')">
            <div style="margin-top: 9px;">
              <span class="main-box-title-14">Summary</span>
            </div>
        </div>
        <div class="separator"></div>
        <div class="button-container right" [ngClass]="{'selected': isSelected('charts')}" (click)="selectMenuItem('charts')">
            <div style="margin-top: 8px;">
              <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;" src="./assets/images/extra_tab_icons/charts-icon.svg">
                <span class="main-box-title-14" style="padding-top: 2px;">Charts</span>
            </div>
        </div>
    </div>
    <span class="main-box-title-16">Word List</span>
    <span class="main-box-title-14"><br>This tool analyses your text according to the Academic Word List or AWL
        (Coxhead, 2000).
        Click <a href="https://textinspector.com/help/academic-word-list-and-phrases/" class="hiperlinks" target="_blank" rel="noopener noreferrer">HERE</a> for an explanation. It also analyses your text in terms of key Phrases identified by Martinez and
        Schmitt (Martinez and Schmitt, 2012), identified as K1, K2 and so on, as discussed <a href="https://textinspector.com/help/analysing-vocabulary-using-the-phrase-list/" class="hiperlinks" target="_blank" rel="noopener noreferrer">HERE</a>.
        If you want to correct any analysis, go to Input below, change the tag, then click Update.</span>
    

    <!--------------------------------------------->
    <!--------------------------------------------->
    <!-----------------WORD LIST------------------->
    <!--------------------------------------------->
    <!--------------------------------------------->

    <ng-container *ngIf="selectedMenuItem === 'summary'">


        <div id="buttons-box">
            <div style="width: 70px;">

            </div>
            <span style="padding-left: 15px;">
                <button class="icon-button">
                  <span class="button-block"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" class="export-con"></div><span>Lexis: AWL
                    Export</span></span>
                </button>

            </span>

        </div>
        
        <ng-container *ngIf="checked">

            <!--------------------------->
            <!--------------------------->
            <!------Advanced Mode-------->
            <!--------------------------->
            <!--------------------------->
            <div class="div_scroll_box">
            <div id="awl-box">
                <div style="width: 70px;">
                    <button mat-button style="visibility: hidden; display: inline-block;">
                        <img class="eye-icon" style="padding-left: 10px;" src="./assets/images/eye-icon.svg">
                        <span class="main-box-title-12">See All</span>
                    </button>
                </div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">Word</div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 90px; ">Types</div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">Tokens</div>
                <div style=" text-align: left; width: 65px; ">
                    <div class="main-box-title-12">Cumul %</div>
                    <div class="main-box-title-12">Types</div>
                </div>
                <div style=" text-align: left; width: 70px; ">
                    <div class="main-box-title-12">Cumul %</div>
                    <div class="main-box-title-12">Tokens</div>
                </div>
                <div style="width: 32px; height: 20px; "></div>
            </div>

            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL_T']}" (click)="toggleExpand('AWL_T')">
                  <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                  <span id="box-score" style="color: #2A3654;">AWL Total</span>
                  <div class="main-box-title-14" id="div_tokens_total">{{types_total ? types_total : "--"}} (5.11%)</div>
                  <div class="main-box-title-14" id="div_tokens_total">{{tokens_total ? tokens_total : "--"}} (3.90%)</div>
                  <div style="width: 50px; height: 10px; "></div>
                  <div style="width: 50px; height: 10px; "></div>
                  <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL_T']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL_T']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL1']}" (click)="toggleExpand('AWL1')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #F60D16;">AWL1</span>
                <div class="main-box-title-14" id="div__types">{{types_AWL1 ? types_AWL1 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_AWL1 ? words_AWL1 : "--"}} (0.30%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_AWL1 ? cumul_types_AWL1 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_AWL1 ? cumul_tokens_AWL1 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL1']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL1']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL2']}" (click)="toggleExpand('AWL2')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #C5C500;">AWL2</span>
                <div class="main-box-title-14" id="div__types">{{types_AWL2 ? types_AWL2 : "--"}} (1.28%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_AWL2 ? words_AWL2 : "--"}} (0.90%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_AWL2 ? cumul_types_AWL2 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_AWL2 ? cumul_tokens_AWL2 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL2']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL2']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL5']}" (click)="toggleExpand('AWL5')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #8E8E5B;">AWL5</span>
                <div class="main-box-title-14" id="div__types">{{types_AWL5 ? types_AWL5 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_AWL5 ? words_AWL5 : "--"}} (0.30%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_AWL5 ? cumul_types_AWL5 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_AWL5 ? cumul_tokens_AWL5 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL5']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL5']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL7']}" (click)="toggleExpand('AWL7')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #6C2D8E;">AWL7</span>
                <div class="main-box-title-14" id="div__types">{{types_AWL7 ? types_AWL7 : "--"}} (0.85%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_AWL7 ? words_AWL7 : "--"}} (0.90%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_AWL7 ? cumul_types_AWL7 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_AWL7 ? cumul_tokens_AWL7 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL7']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL7']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL8']}" (click)="toggleExpand('AWL8')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #5BC52D;">AWL8</span>
                <div class="main-box-title-14" id="div__types">{{types_AWL8 ? types_AWL8 : "--"}} (0.74%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_AWL8 ? words_AWL8 : "--"}} (0.47%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_AWL8 ? cumul_types_AWL8 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_AWL8 ? cumul_tokens_AWL8 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL8']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL8']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL9']}" (click)="toggleExpand('AWL9')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #0075FF;">AWL9</span>
                <div class="main-box-title-14" id="div__types">{{types_AWL9 ? types_AWL9 : "--"}} (1.28%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_AWL9 ? words_AWL9 : "--"}} (0.90%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_AWL9 ? cumul_types_AWL9 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_AWL9 ? cumul_tokens_AWL9 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL9']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL9']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K2']}" (click)="toggleExpand('K2')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #2540F8;">K2</span>
                <div class="main-box-title-14" id="div__types">{{types_K2 ? types_K2 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_K2 ? words_K2 : "--"}} (0.30%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_K2 ? cumul_types_K2 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_K2 ? cumul_tokens_K2 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K2']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K2']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
              
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K3']}" (click)="toggleExpand('K3')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #15622B;">K3</span>
                <div class="main-box-title-14" id="div__types">{{types_K3 ? types_K3 : "--"}} (1.28%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_K3 ? words_K3 : "--"}} (0.90%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_K3 ? cumul_types_K3 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_K3 ? cumul_tokens_K3 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K3']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K3']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K4']}"  (click)="toggleExpand('K4')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #F75F1C;">K4</span>
                <div class="main-box-title-14" id="div__types">{{types_K4 ? types_K4 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_K4 ? words_K4 : "--"}} (0.30%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_K4 ? cumul_types_K4 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_K4 ? cumul_tokens_K4 : "--"}}%</div>
                <mat-icon class="expand-icon">expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K4']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K4']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K5']}" (click)="toggleExpand('K5')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <span id="box-score" style="background-color: #1A8583;">K5</span>
                <div class="main-box-title-14" id="div__types">{{types_K5 ? types_K5 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens">{{words_K5 ? words_K5 : "--"}} (0.30%)</div>
                <div class="main-box-title-14" id="div_c_types">{{cumul_types_K5 ? cumul_types_K5 : "--"}}%</div>
                <div class="main-box-title-14" id="div_c_tokens">{{cumul_tokens_K5 ? cumul_tokens_K5 : "--"}}%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K5']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K5']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['UNLISTED']}" (click)="toggleExpand('UNLISTED')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="display: flex;">
                  <span id="box-score" style="background-color: #F3F3F5; color: #2A3654;">Unlisted</span>
                  <div class="tooltip-container">
                    <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                    <span class="tooltip-text">Words in your text that are not found in the AWL word list.</span>
                  </div>
                </div>
                
                <div class="main-box-title-14" id="div__types_u">{{types_unlisted ? types_unlisted : "--"}} (92.34%)</div>
                <div class="main-box-title-14" id="div_tokens_u">{{words_unlisted ? words_unlisted : "--"}} (94.29%)</div>
                <div class="main-box-title-14" id="div_c_types_u">~100%</div>
                <div class="main-box-title-14" id="div_c_tokens_u">~100%</div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['UNLISTED']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['UNLISTED']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
              
        </ng-container>

        <!--------------------------->
        <!--------------------------->
        <!--------Simple Mode-------->
        <!--------------------------->
        <!--------------------------->

        <ng-container *ngIf="!checked">
          <div class="div_scroll_box">
            <div id="awl-box" >
                <div style=" margin-left: 10px; margin-right: 2%; " >
                    <button mat-button style="align-items: flex-end; display: flex; ">
                        <img class="eye-icon" style="margin-right: 2px; padding-bottom: 3px;" src="./assets/images/eye-icon.svg">
                        <span class="main-box-title-12">See All</span>
                    </button>
                </div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">Word</div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 110px; ">Types</div>
                <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">Tokens</div>
                <div style="width: 125px; height: 10px; "></div>
            </div>

            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL_T']}" (click)="toggleExpand('AWL_T')">
                  <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                  <div style="width: 60px; height: 20px; "></div>
                  <div id="div_box_score_total_S">
                    <span id="box-score" style="color: #2A3654;">AWL Total</span>
                  </div>
                  <div class="main-box-title-14" id="div_tokens_total_S">{{types_total ? types_total : "--"}} (5.11%)</div>
                  <div class="main-box-title-14" id="div_tokens_total_S">{{tokens_total ? tokens_total : "--"}} (3.90%)</div>
                  <div style="width: 40px; height: 20px; "></div>
                  <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL_T']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL_T']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL1']}" (click)="toggleExpand('AWL1')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #F60D16;">AWL1</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_AWL1 ? types_AWL1 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_AWL1 ? words_AWL1 : "--"}} (0.30%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL1']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL1']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL2']}" (click)="toggleExpand('AWL2')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #C5C500;">AWL2</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_AWL2 ? types_AWL2 : "--"}} (1.28%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_AWL2 ? words_AWL2 : "--"}} (0.90%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL2']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL2']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
              
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL5']}" (click)="toggleExpand('AWL5')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #8E8E5B;">AWL5</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_AWL5 ? types_AWL5 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_AWL5 ? words_AWL5 : "--"}} (0.30%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL5']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL5']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL7']}" (click)="toggleExpand('AWL7')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #6C2D8E;">AWL7</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_AWL7 ? types_AWL7 : "--"}} (0.85%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_AWL7 ? words_AWL7 : "--"}} (0.90%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL7']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL7']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL8']}" (click)="toggleExpand('AWL8')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #5BC52D;">AWL8</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_AWL8 ? types_AWL8 : "--"}} (0.74%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_AWL8 ? words_AWL8 : "--"}} (0.47%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL8']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL8']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['AWL9']}" (click)="toggleExpand('AWL9')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #0075FF;">AWL9</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_AWL9 ? types_AWL9 : "--"}} (1.28%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_AWL9 ? words_AWL9 : "--"}} (0.90%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['AWL9']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['AWL9']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K2']}" (click)="toggleExpand('K2')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #2540F8;">K2</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_K2 ? types_K2 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_K2 ? words_K2 : "--"}} (0.30%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K2']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K2']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K3']}" (click)="toggleExpand('K3')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #15622B;">K3</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_K3 ? types_K3 : "--"}} (1.28%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_K3 ? words_K3 : "--"}} (0.90%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon">expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K3']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K3']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K4']}" (click)="toggleExpand('K4')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #F75F1C;">K4</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_K4 ? types_K4 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_K4 ? words_K4 : "--"}} (0.30%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K4']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K4']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['K5']}" (click)="toggleExpand('K5')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 60px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #1A8583;">K5</span>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_K5 ? types_K5 : "--"}} (0.43%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_K5 ? words_K5 : "--"}} (0.30%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['K5']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['K5']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vertical-box">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['UNLISTED']}" (click)="toggleExpand('UNLISTED')">
                <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
                <div style="width: 0px; height: 20px;"></div>
                <div id="div_box_score_S">
                  <span id="box-score" style="background-color: #F3F3F5; color: #2A3654;">Unlisted</span>
                  <div class="tooltip-container">
                    <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                    <span class="tooltip-text">Lorem ipsum dolor sit amet consetetur sad ipscing elitr sed diam nonumy eirmod temi por invidunt ut labore et dolore magna.</span>
                  </div>
                </div>
                <div class="main-box-title-14" id="div__types_S">{{types_unlisted ? types_unlisted : "--"}} (92.34%)</div>
                <div class="main-box-title-14" id="div_tokens_S">{{words_unlisted ? words_unlisted : "--"}} (94.29%)</div>
                <div style="width: 40px; height: 20px;"></div>
                <mat-icon class="expand-icon" >expand_more</mat-icon>
              </div>
              <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['UNLISTED']">
                <div class="vertical-box" *ngFor="let chunk of dividedData['UNLISTED']" style="border: none; margin-bottom: 0px; padding: 0px;">
                  <div *ngFor="let item of chunk">
                    <p class="text-item">{{item.word}} / {{item.count}}</p>
                  </div>
                </div>
              </div>
            </div>            
          </div>
        </ng-container>

        <!-- <div class="content-show-all">
          <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()">
            Expand all
          </button>
        </div> -->
    </ng-container>

    <!--------------------------------------------->
    <!--------------------------------------------->
    <!----------------WORD CHARTS------------------>
    <!--------------------------------------------->
    <!--------------------------------------------->

    <ng-container *ngIf="selectedMenuItem === 'charts'">
        <div class="chart-container">
            <div
                style="width: auto;align-items: center; text-align: center; font-size: 14px; font-weight: bold; font-family: 'Inter';color: #2A3654; margin-bottom: 20px;">
                Types %</div>
            <canvas style="width: 70%; height: 200px; margin-left: 1%;margin-right: 1%; padding-bottom: 10px;" baseChart
                [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
            </canvas>
        </div>
    </ng-container>

    <ng-container *ngIf="!checked">
        <div class="text-box-bottom-simple-mode">
            <div class="line-box-bottom-simple-mode">
                <div class="bottom-text-line-simple-mode"></div>
            </div>
            <span class="main-box-title-14">To see full statistics, switch to “Advanced Mode”.</span>
        </div>
    </ng-container>

</mat-card-content>
